export { default as WReportComments } from '@/widgets/WReportComments/WReportComments.vue'
